import { TrackingComposite } from './TrackingComposite'
import { TrackingFactory } from './TrackingFactory'
import { TrackingCommand } from './TrackingInterface'
import { eventQueue } from './EventQueue'

export class TrackingService {
  private static instance: TrackingService
  private readonly composite: TrackingComposite
  private enabled = false

  private constructor() {
    this.composite = new TrackingComposite()
  }

  public static getInstance(): TrackingService {
    if (!TrackingService.instance) {
      TrackingService.instance = new TrackingService()
    }
    return TrackingService.instance
  }

  public async enable() {
    this.enabled = true
    await eventQueue.setEnabled(true)
    console.info('[TrackingService] Tracking ENABLED')
  }

  public async disable() {
    this.enabled = false
    await eventQueue.setEnabled(false)
    console.info('[TrackingService] Tracking DISABLED')
  }

  /**
   * Add a command to the composite and execute it immediately.
   * @param type - Command type to execute.
   * @param data - Data required for the command execution.
   */
  addAndExecuteCommand(type: string, data?: any): void {
    const command = TrackingFactory.createCommand(type)
    this.composite.add(command)
    command.execute(data)
  }

  /**
   * Add a command without immediate execution.
   * @param type - Command type.
   */
  addCommand(type: string): void {
    const command = TrackingFactory.createCommand(type)
    this.composite.add(command)
  }

  /**
   * Execute all commands in the composite with the provided data.
   * @param data - Data for executing all commands.
   */
  executeAll(data: any): void {
    this.composite.execute(data)
  }

  /**
   * Remove a specific command from the composite.
   * @param command - The command to remove.
   */
  removeCommand(command: TrackingCommand): void {
    this.composite.remove(command)
  }

  /**
   * Clear the composite to remove all queued commands.
   */
  clearCommands(): void {
    this.composite.clear()
  }
}
